// Scroll Animation Handler
let _scrollHandler = null;

function initScrollAnimations() {
  // Remove previous listener to prevent stacking
  if (_scrollHandler) {
    window.removeEventListener('scroll', _scrollHandler);
    _scrollHandler = null;
  }

  document.body.classList.add('js-enabled');
  
  document.querySelectorAll('.slide-in-left, .slide-in-right, .fade-in').forEach(el => {
    el.classList.add('active');
  });

  setTimeout(() => {
    const animatedElements = document.querySelectorAll('.slide-in-left, .slide-in-right, .fade-in');
    
    _scrollHandler = () => {
      animatedElements.forEach(element => {
        const rect = element.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        
        const isInViewport = (
          rect.top <= windowHeight * 0.85 && 
          rect.bottom >= windowHeight * 0.15
        );
        
        if (isInViewport) {
          element.classList.add('active');
        } else {
          element.classList.remove('active');
        }
      });
    };
    
    _scrollHandler();
    window.addEventListener('scroll', _scrollHandler);
  }, 100);
}

// Initialize animations
document.addEventListener('DOMContentLoaded', initScrollAnimations);

// Make function available globally for React to call
window.initScrollAnimations = initScrollAnimations;
